import type { GoalBannerLevel } from "~/hooks/learning-center/transformers";

import LevelCard from "./level-card";
import LevelInstructionsCard from "./level-instructions-card";
import type { GoalBannerEnrollment } from "./types";

/**
 * Port of hec-composable `goal-banner/levelCards.jsx`. The "Your Lessons"
 * instructions card followed by one card per level.
 *
 * Delta vs composable: the mobile-only `Carousel` (gated by `useMediaQuery`) is
 * replaced with a CSS-responsive flex (`flex-col` → `sm:flex-row`), matching the
 * level.tsx convention of avoiding the hook's hydration/CLS flash. The card
 * count is small (instructions + 1–2 levels), so a stacked column on mobile is
 * acceptable; revisit if goals grow many levels.
 */
const LevelCards = ({
  levels,
  enrollment,
}: {
  levels: GoalBannerLevel[];
  enrollment: GoalBannerEnrollment;
}) => (
  <div className="m-auto mt-4 flex flex-col justify-center gap-4 sm:flex-row">
    <LevelInstructionsCard />
    {levels?.map((level, index) => (
      <LevelCard
        key={level.levelID ?? index}
        index={index}
        level={level}
        enrollment={enrollment}
      />
    ))}
  </div>
);

export default LevelCards;
